<template>
    <ValidationProvider :name="label" :rules="rules" v-slot="{ errors, required }" :vid="computedVid" slim>
        <div class="migrol-form__input-wrapper" :class="{ 'migrol-form__input-wrapper--error' : errors.length > 0 }">
            <label :for="$id('input')" class="migrol-form__input-label" v-if="label && showLabel">{{label}}{{(required ? '*' : '')}}</label>
            <VueSelect :placeholder="label"
                       v-model="selectedValue"
                       @search="fetchOptions"
                       transition=""
                       :options="options"
                       :clearable="false"
                       :searchable="searchable"
                       :disabled="disabled"
                       :selectOnTab="true">
                <template #no-options="{ search, searching, loading }">
                    <div v-show="search.length < 3">{{Strings['Global.PlzOrtDropdown_Instructions']}}</div>
                    <div v-show="search.length >= 3 && searching && loading">{{Strings['Global.PlzOrtDropdown_Searching']}}</div>
                    <div v-show="search.length >= 3 && searching && !loading">{{Strings['Global.PlzOrtDropdown_NoResults']}}</div>
                </template>
            </VueSelect>
            <div class="migrol-form__error-message">{{errors[0]}}</div>
        </div>
    </ValidationProvider>
</template>

<script>
    import $ from 'jQuery';
    import { ValidationProvider } from 'VeeValidate';

    export default {
        inheritAttrs: false,
        props: {
            label: {
            },
            showLabel: {
                type: Boolean,
                default: true
            },
            flex: {
                type: String,
                default: '1',
                required: false
            },
            zipCity: {
                type: Object,
                validator: function (value) {
                    if (value != null) {
                        if (typeof value.zipcode === 'undefined' || typeof value.city === 'undefined')
                            return false;
                    }
                    return true;
                }
            },
            disabled: {
                type: Boolean,
                default: false
            },
            rules: {
                type: [Object, String],
                default: null,
                required: false
            },
            vid: {
                type: String,
                default: ''
            }
        },
        computed: {
            computedStyle() {
                return this.flex != '1' ? { flex: this.flex } : null;
            },
            computedVid() {
                if (this.vid !== '')
                    return this.vid;
                else
                    return this.$id('vid');
            },
            Strings() {
                return this.$migrolVueLibraryData.Strings;
            }
        },
        data() {
            return {
                selectedValue: '',
                options: [],
                debounceToken: null
            }
        },
        watch: {
            zipCity(newZipCity) {
                this.updateSelectedValue(newZipCity)
            },
            selectedValue(newSelectedValue, oldSelectedValue) {
                if (newSelectedValue && oldSelectedValue) {
                    if (
                        parseInt(newSelectedValue.zipcode) != parseInt(oldSelectedValue.zipcode)
                        || newSelectedValue.city != oldSelectedValue.city
                        || newSelectedValue.countryCode != oldSelectedValue.countryCode
                    )
                        this.$emit('change', newSelectedValue);
                } else if (newSelectedValue == null) {
                    this.$emit('change', { zipcode: null, city: null, countryCode: null });
                } else if (newSelectedValue != oldSelectedValue) {
                    this.$emit('change', newSelectedValue);
                }
            }
        },
        methods: {
            fetchOptions(search, loading) {
                if (search && search.length >= 3) {
                    var vm = this;
                    if (vm.debounceToken)
                        clearTimeout(vm.debounceToken);

                    vm.debounceToken = setTimeout(() => {
                        loading(true);
                        $.getJSON('/migrolapi/' + window.CONFIG.language + '/places/ZipcodeCityLookup?term=' + encodeURI(search))
                            .done(function (data) {
                                vm.options = data.results;
                            })
                            .always(function () {
                                loading(false);
                            });
                    }, 350);
                }
            },
            updateSelectedValue(newZipCity) {
                if (newZipCity && newZipCity.zipcode && newZipCity.city && newZipCity.countryCode) {
                    var newOptions = [];
                    newZipCity.label = newZipCity.zipcode + ' ' + newZipCity.city;
                    newOptions.push(newZipCity);
                    this.options = newOptions;
                    this.selectedValue = newZipCity;
                } else {
                    this.options = [];
                    this.selectedValue = '';
                }
            }
        },
        mounted() {
            //if we have an address with zip and city, init the value in the dropdown
            this.updateSelectedValue(this.zipCity);
        },
        components: {
            ValidationProvider
        }
    }
</script>